;
var GENESIS = window.GENESIS || {};
GENESIS.settings = GENESIS.settings || {};


 GENESIS.settings = {
 isDevice:false,
 isIE:false,
 };

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
var videotest;
(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        //body class set by Mobile_Detect.php in extras.php
        if ($("body").hasClass("device")){
            GENESIS.settings.isDevice = true;
        }

        if ($("body").hasClass("ie")){
            GENESIS.settings.isIE = true;
        }
        //This is the mobile nav
        // 0 = hide, 1 = visible
        var menuState = 0;

        //if($(".mini-menu-options").is(":hidden")) {
        $(".navbar-toggle").on("click",function() {
          $(".mini-menu-options").animate({
            width: "toggle"
          }, function() {
            if(menuState === 0) {
              menuState = 1;
            } else {
              $(".mini-menu-options").css('display', 'none');
              menuState = 0;
            }
          });

          if(menuState === 0) {
            //show the close button
            $(this).removeClass('collapsed');
            $(".mini-menu-options").css('display', 'inline-block');
          } else {
            //show the menu button
            $(this).addClass('collapsed');

          }
        });


        //faq page toggle
        $(".faq-item").click(function(){
          $(this).toggleClass('open');
        })

        //loading news button more news items
        //news_items = $('.news-block').size();
        //x = 4;
        //$('.news-block:lt('+x+')').show();
        //$('.news-button').click(function () {
        //  x = (x+4 <= news_items) ? x+4 : news_items;
        //  $('.news-block:lt('+x+')').slideDown();
        //});
        //if(!x<=4){
        //  $('.news-button').css('display', 'block');
        //}else{
        //  $('.news-button').css('display', 'none');
        //}

        var limit = 4;
        var per_page = 4;
        jQuery('.news-block:gt('+(limit-1)+')').hide();
        if (jQuery('.news-block').length <= limit) {
          jQuery('.news-button').hide();
        }

        jQuery('.news-button').bind('click', function(event){
          event.preventDefault();
          limit += per_page;
          jQuery('.news-block:lt('+(limit)+')').slideDown();
          if (jQuery('.news-block').length <= limit) {
            jQuery(this).hide();
          }
        });



        //video open and close
        $('a[data-videoid]').click(function(e){
          e.preventDefault();

          var video = $(this).attr('data-videoid');

          if($('.video-overlay').hasClass('closed')){
            $('[data-videoid="' + video + '"]').show().removeClass("closed");
            $('.video-overlay').not('[data-videoid="' + video + '"]').addClass("closed");
          }else{
            $(".video-overlay").addClass("closed");
            setTimeout(function(){ $('.video-overlay').addClass("closed"); }, 1000);
          }
          //
          return false;
        });

        $('a.video-close, .video-overlay').click(function(e){
          e.preventDefault();
          //
          $('.video-overlay').addClass("closed");
          if(!$('.video-overlay').is('.closed')){
            //$('.video-overlay').addClass("closed");
            setTimeout(function(){ $('.video-overlay').addClass("closed") }, 1000);
          }
          //
          return false;
        });

        //match heights
        $.fn.matchHeight._maintainScroll = true;
        $('.news-container').matchHeight();
        $('.about-match-height').matchHeight();
        $('.video-match-height').matchHeight();
        $('.match-height').matchHeight();


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {


        //function setupSlideshow(){
          $('.slideshow').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite:false,
            dots: true,
            arrows:false,
            centerMode: true,
            centerPadding: '15%',
            focusOnSelect: true
          });
          
          //$(".mouse-down").click(function(){
          //  $.fn.fullpage.moveSectionDown();
          //})

        //desktop only
        if (GENESIS.settings.isDevice==false){


          var startSlickAutoplay = false;//starts in section 6
          //};

          var showIntroTimer = setTimeout(function(){
            $("#genesis-intro").addClass("active");
            $("#intro").addClass("loaded");
          },800);

          setTimeout(function(){
            $("#intro .copy").removeClass("removed");
          },500);


          var introVideo = $("#genesis-intro video")[0];
          /*
          var videoStartTime = 0;
          var durationTime = 1;

          //won't be needed later when there is a short auto looping video
          introVideo.addEventListener('loadedmetadata', function() {
            videoStartTime = 0;
            durationTime = 1;
            this.currentTime = videoStartTime;
            this.play();
          }, false);

          introVideo.addEventListener('timeupdate', function() {
            if(this.currentTime > videoStartTime + durationTime){
            this.currentTime= videoStartTime;
            }
          });
          */




          var video = $("#genesis-video video")[0];


          //make sure to release the scroll if the video has ended
          video.onended = function(e) {
            $.fn.fullpage.setAllowScrolling(true);
          };


          //var videoStartTime = 0;
          var durationTime = '00:00:00:01';
          var videoDirection = 'forward';

          var intervalRewind;

          var currentFrame;

          var vidFps;

          if(GENESIS.settings.isIE){
            vidFps = 30;
          }else{
            vidFps = 24;
          }
          //vidFps = 30;

          function rewindSegment(){
            //console.log(video.buffered.end(0));
            //console.log(video.duration,durationTime);

            //so slow//TweenMax.to(video, video.duration, {currentTime:durationTime, ease:Linear.easeNone});
            
            intervalRewind = setInterval(function(){

              //console.log(videotest.get(),durationTime,videotest.toFrames(durationTime));
              if(videotest.get() <= videotest.toFrames(durationTime)){
                clearInterval(intervalRewind);
                video.pause();
                //console.log('pause and allow scrolling');
                $.fn.fullpage.setAllowScrolling(true);
              }
              else{

                //video.currentTime += -.3;
                currentFrame = videotest.get();//gets current frame
                //console.log(currentFrame);
                videotest.seekTo({ frame: currentFrame-1 });
              }

            }, 1000 / vidFps );
            //video 24fps
            //one interval per frame  1000 / 24 / 2
          }


  /*
          video.addEventListener('loadedmetadata', function() {
            videoStartTime = 0;
            durationTime = 1;
            this.currentTime = videoStartTime;
            
          }, false);

          video.addEventListener('timeupdate', function() {
            //console.log(this.currentTime);
            if (videoDirection == 'forward'){
              if(this.currentTime >= videoStartTime + durationTime - .2){
              this.pause();
              $.fn.fullpage.setAllowScrolling(true);
              }
            }
          });
  */

          videotest = VideoFrame({
              id : 'timingvideo',
              frameRate: FrameRates.film,
              callback : function(response) {
                  //console.log('callback response: ' + response,durationTime);
                  if (response == durationTime){//'00:00:03:00'){
                    video.pause();
                    $.fn.fullpage.setAllowScrolling(true);
                  }
              }
          });
          videotest.listen("SMPTE");



          var videoStops = [
          '00:00:00:01',
          '00:00:03:16',
          '00:00:06:14',
          '00:00:14:05',
          '00:00:20:23',
          '00:00:27:06',
          '00:00:30:02'
          ];


          function showImageOverlay(currentSlide){
            var className;
            switch (currentSlide) {
                case 1:
                    className = "screen1";
                    break;
                case 2:
                    className = "screen2";
                    break;
                case 3:
                    className = "screen3";
                    break;
                case 4:
                    className = "screen4";
                    break;
                case 5:
                    className = "screen5";
                    break;
                case 6:
                    className = "screen6";
                    break;
                case 7:
                    className = "screen7";
                    break;
            }
            $("#image-overlay").attr("class",className +" active");
          }


          $('#home-container').fullpage({

            navigation: true,
            navigationPosition: 'left',
            scrollingSpeed: 1500,
            keyboardScrolling: false,
            fitToSectionDelay: 1000,
            animateAnchor: false,//don't animate to section when loading anchor
            //can't repeat names of anchors
            //anchors:['-intro','-the-breakthrough','-unparalleled-performance','-designed-for-robots','-empowering-new-designs','-inspiring-new-forms-of-robots','-new-markets'],
            //anchors:['livedrive','the-breakthrough','unparalleled','for-robots','new-designs','new-forms','markets'],
            //navigationTooltips: ['LiveDrive', 'The Breakthrough'],
            onLeave: function(index, slideIndex, direction){
  
              var timeChange = 1500;
              var delayForSkipSlide = 1500;
              //console.log(index,'slideIndex=',slideIndex,direction,'videoStops='+videoStops[slideIndex-1]);
              $.fn.fullpage.setAllowScrolling(false);
              $("#fp-nav").addClass("disabled");

              $("#image-overlay").attr("class","");
              
              //intro transition video out
              if (index == 1 && slideIndex == 2){//go to second slide from first slide
                introVideo.pause();
                $("#genesis-intro").addClass("removed").removeClass("active");
                clearTimeout(showIntroTimer);
                $("#genesis-video").removeClass("removed");
                //$(".mouse-down").removeClass("active");
              }else if (slideIndex == 1){//back to first slide
                var delayReturningIntro;
                if (slideIndex>index+1 || slideIndex<index-1){//skipping more than 1 slide
                  delayReturningIntro = delayForSkipSlide;
                }else{
                  delayReturningIntro = videotest.toMilliseconds(videoStops[1]);
                }
                
                video.pause();
                setTimeout(function(){
                  introVideo.play();
                  $("#genesis-intro").removeClass("removed");
                  $(".mouse-down").addClass("active");
                  $("#fp-nav").removeClass("disabled");
                  //$("#genesis-video").addClass("removed");//doesn't look as smooth
                },delayReturningIntro);
              }else{//any slide that isn't first
                $("#genesis-intro").addClass("removed").removeClass("active");
                clearTimeout(showIntroTimer);
                //$(".mouse-down").removeClass("active");
                $("#genesis-video").removeClass("removed");
              }


              //index is of slide leaving
              //slideIndex is where you're going
              if (slideIndex>index+1 || slideIndex<index-1 || (GENESIS.settings.isIE && direction=="up")){//skipping more than 1 slide or IE

                
                    //console.log(videoStops[slideIndex-1]);

                if (slideIndex == 1){//back to first slide skipping 2
                    //don't fade out for this, intro video fades in over top
                    video.pause();
                    setTimeout(function(){
                      videotest.seekTo({ SMPTE: videoStops[slideIndex-1] });
                    },200)
                    $.fn.fullpage.setAllowScrolling(true);
                    $("#genesis-video").addClass("removed");
                }else{
                
                  introVideo.pause();
                  $("#genesis-intro").addClass("removed");


                  video.pause();
                  $("#genesis-video").fadeOut(200,function(){

                    $("#image-overlay").attr("class","");
                    showImageOverlay(slideIndex-1);

                    //console.log('fadeout='+videoStops[slideIndex-1]);
                    //video.currentTime = videoStops[slideIndex-1];
                    videotest.seekTo({ SMPTE: videoStops[slideIndex-1] });
                    $(this).fadeIn(1200);
                    $.fn.fullpage.setAllowScrolling(true);
                  })
                }

                //text transition
                setTimeout(function(){
                  $("#home-container .section").eq(slideIndex-1).addClass("animate");
                  //console.log('add animate to slideIndex-1');
                  $("#fp-nav").removeClass("disabled");
                },delayForSkipSlide);

              }else{//only changing one slide position

                

                if (direction=="down"){
                  //videoDirection = "forward";
                  durationTime = videoStops[slideIndex-1];

                  timeChange = videotest.toMilliseconds(videoStops[slideIndex-1]) - videotest.toMilliseconds(videoStops[index-1]);

                  /*if (slideIndex==2){
                    durationTime = 4;
                  }else if(slideIndex==3){
                    durationTime = 12;
                  }
                  else if(slideIndex==4){
                    durationTime = 20;
                  }*/

                  clearInterval(intervalRewind);
                  video.play();

                }else if(direction=="up"){
                  //videoDirection = "reverse";
                  video.pause();

                  durationTime = videoStops[slideIndex-1];

                  timeChange = videotest.toMilliseconds(videoStops[index-1]) - videotest.toMilliseconds(videoStops[slideIndex-1]);

                  /*
                  if (slideIndex==1){
                    //TweenMax.to(video, video.duration, {currentTime:0, ease:Linear.easeNone});
                    durationTime = 0;

                    rewindSegment();
          
                  }else if(slideIndex==2){
                    //TweenMax.to(video, video.duration, {currentTime:4, ease:Linear.easeNone});
                    
                    durationTime = 4;
                    rewindSegment();

                  }else if(slideIndex==3){
                    
                    //TweenMax.to(video, video.duration, {currentTime:12, ease:Linear.easeNone});
                    durationTime = 12;
                    rewindSegment();

                  }
                  */
                  clearInterval(intervalRewind);
                  rewindSegment();
                }



                timeChange = timeChange;// - 400;//start half a second before end
                //text transition
                setTimeout(function(){
                  $("#home-container .section").eq(slideIndex-1).addClass("animate");
                  $("#fp-nav").removeClass("disabled");

                  $("#image-overlay").attr("class","");
                  showImageOverlay(slideIndex-1);

                },timeChange);

              }



              

              //specific slide actions
              if (slideIndex == 6){
                
                if (startSlickAutoplay==false){
                  startSlickAutoplay = true;
                  setTimeout(function(){
                    //$(".slideshow").slick('slickGoTo',1);
                    $(".slideshow").slick('slickPlay');
                  },2000)
                }

                //setupSlideshow();
              }
              if (slideIndex == 7){//last slide
                setTimeout(function(){
                  $(".footer-home").addClass("active");
                },timeChange);
                $(".mouse-down").removeClass("active");
              }else{
                $(".footer-home").removeClass("active");
                $(".mouse-down").addClass("active");
              }
             


              //console.log('animate remove='+index);
              $("#home-container .section").eq(index-1).removeClass("animate");


            },
            afterLoad: function(anchorLink, index){
               
            },
            afterRender: function(){//docs say other plugin init code should go here
              setTimeout(function(){
                $(".mouse-down").addClass("active");
              },5000);
            },
            afterSlideLoad:function (anchorLink, index, slideAnchor, slideIndex){

            }
          });
        }else{//if mobile or other device

            setTimeout(function(){
              //$(".slideshow").slick('slickGoTo',1);
              $(".slideshow").slick('slickPlay');
            },2000)
        }

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

    $(function(){ /* to make sure the script runs after page load */

        $('.blurb').each(function(event){ /* select all divs with the item class */

            var max_length = 840; /* set the max content length before a read more link will be added */
console.log($(this).html().length);

            if($(this).html().length > max_length){ /* check for content length */

                var short_content 	= $(this).html().substr(0,max_length); /* split the content in two parts */
                var long_content	= $(this).html().substr(max_length);
console.log('short='+short_content);console.log("long="+long_content);
                $(this).html(short_content+
                '<span class="more_text" style="display:none;">'+long_content+'</span>'+ /* Alter the html to allow the read more functionality */
                ' <a href="#" class="read_more"> Read More</a>');

                $(this).find('a.read_more').click(function(event){ /* find the a.read_more element within the new html and bind the following code to it */

                    event.preventDefault(); /* prevent the a from changing the url */
                    
                    if ($(this).parents('.blurb').find('.more_text').is(":visible")){
                      $(this).text('Read More');
                      $(this).parents('.blurb').find('.more_text').hide();
                    }else{
                      //$(this).hide(); /* hide the read more button */
                      $(this).text('Read Less');
                      $(this).parents('.blurb').find('.more_text').show(); /* show the .more_text span */
                      
                    }


                    //$('.about-match-height:nth-child(1), .about-match-height:nth-child(2)').css("height", "1300px");
                    $('.about-match-height').matchHeight();

                });

            }

        });


    });



})(jQuery); // Fully reference jQuery after this point.
